<template>
  <div class="forgot-password-page" :style="{ height: documentClientHeight }">
    <div class="logo">
      <i></i>
      <span>修改密码</span>
    </div>
    <div class="about">
      <i></i>
      <a
        href="https://www.z-easy.com.cn/"
        target="_blank"
      >关于一咻</a>
    </div>
    <div class="wrapper">
      <div
        v-if="[1, 2].includes(stepIndex)"
        class="steps"
        :class="{ finish: stepIndex === 2 }"
      >
        <div
          class="item"
          :class="{ active: stepIndex >= 1 }"
        >
          <div class="hd">
            <i>1</i>
          </div>
          <div class="title">验证账号</div>
        </div>
        <div
          class="item"
          :class="{ active: stepIndex >= 2 }"
        >
          <div class="hd">
            <i>2</i>
          </div>
          <div class="title">设置新密码</div>
        </div>
      </div>

      <el-form
        class="data-form"
        label-position="top"
        :model="dataForm"
        :rules="rules"
        @keyup.enter="formSubmit"
        @submit.prevent
        ref="dataForm"
      >
        <!-- 第一步 -->
        <template v-if="stepIndex === 1">
          <el-form-item
            label="登录账号"
            prop="mobile"
          >
            <el-input
              v-model="dataForm.mobile"
              placeholder="请输入登录账号"
            />
          </el-form-item>

          <el-button
            type="primary"
            :loading="btnLoading"
            @click="formSubmit()"
          >下一步</el-button>

          <div class="return">
            <i></i>
            <span @click="$router.push('/login')">返回登录</span>
          </div>
        </template>

        <!-- 第二步 -->
        <template v-else-if="stepIndex === 2">
          <div class="mobile-show">
            <div class="label">手机号码</div>
            <div class="value">
              <span class="number">{{ dataForm.mobile }}</span>
              <span class="tips">提示：点击“获取验证码”，会将验证码发送到该手机号。</span>
            </div>
          </div>

          <el-form-item
            label="验证码"
            prop="mobileCode"
          >
            <el-input
              class="verify-code"
              type="number"
              v-model="dataForm.mobileCode"
              placeholder="请输入验证码"
            >
              <template #append>
                <el-button
                  type="text"
                  plain
                  :disabled="codeDisabled || !dataForm.mobile"
                  @click="getMobileCode()"
                >{{ codeText }}</el-button>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item
            label="新密码"
            prop="newPassword"
          >
            <el-input
              type="password"
              v-model="dataForm.newPassword"
              placeholder="请输入6-18位，包含大小写字母、数字的密码"
            />
          </el-form-item>
          
          <el-form-item
            label="确认新密码"
            prop="confirmPassword"
          >
            <el-input
              type="password"
              v-model="dataForm.confirmPassword"
              placeholder="请再次输入6-18位，包含大小写字母、数字的密码"
            />
          </el-form-item>

          <el-button
            type="primary"
            :loading="btnLoading"
            @click="formSubmit()"
          >确定</el-button>
        </template>

        <!-- 成功 -->
        <template v-else>
          <div class="success">
            <div class="icon"></div>
            <div class="text">恭喜您，您的密码已设置成功！</div>
            <el-button
              size="small"
              @click="$router.push('/login')"
            >返回登录</el-button>
            <el-button
              type="primary"
              size="small"
              @click="sign"
            >进入系统</el-button>
          </div>
        </template>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import vueCookie from 'vue-cookies'
export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      } else {
        // if (/(\w)\1\1/g.test(value)) {
        //   return callback(new Error('密码不能出现3位及以上连续相同字符'))
        // }
        let reg = new RegExp('^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])).{6,18}$')
        if (!reg.test(value)) {
          return callback(new Error('请输入6-18位，包含大小写字母、数字的密码'))
        }
        // const LxStr = (str) => {
        //   const arr = str.split('')
        //   let flag = false
        //   for (let i = 1; i < arr.length - 1; i++) {
        //     const firstIndex = arr[i - 1].charCodeAt()
        //     const secondIndex = arr[i].charCodeAt()
        //     const thirdIndex = arr[i + 1].charCodeAt()
        //     if (
        //       thirdIndex - secondIndex === 1 &&
        //       secondIndex - firstIndex === 1
        //     ) {
        //       flag = true
        //     }
        //   }
        //   return flag
        // }

        // if (LxStr(value)) {
        //   return callback(new Error('密码不允许出现连续3位递增字符'))
        // }
        callback()
      }
    }

    const validateConfirmPassword = (rule, value, callback) => {
      if (this.dataForm.newPassword !== value) {
        callback(new Error('确认密码与新密码不一致'))
      } else {
        callback()
      }
    }

    return {
      documentClientHeight: '100%',
      stepIndex: 1,
      btnLoading: false,
      dataForm: {
        id: ''
      },
      codeText: '获取验证码',
      codeDisabled: false,
      rules: {
        mobile: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value) {
                if (!/^1[0-9]{10}$/.test(value)) {
                  callback(new Error('手机号码错误'));
                }
              }
              callback();
            },
            trigger: 'blur'
          }
        ],
        mobileCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (value) {
                if (value.length !== 5) {
                  callback(new Error('验证码错误'));
                }
              }
              callback();
            },
            trigger: 'blur'
          }
        ],
        newPassword: [
          { validator: validatePass, trigger: 'blur' },
          { required: true, message: '新密码不能为空', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '确认密码不能为空', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      tenants: []
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.documentClientHeight = document.documentElement['clientHeight'] + 'px'
    window.onresize = () => {
      this.documentClientHeight = document.documentElement['clientHeight'] + 'px'
    }
  },

  methods: {
    // 下一步 & 提交
    formSubmit() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.btnLoading = true
          if (this.stepIndex === 1) { // 下一步
            this.$get('/p/user/getUserInfoByLoginName', {
              loginName: this.dataForm.mobile
            }).then(({ data }) => {
              if (data && data.code === 'C0000') {
                if (!data.result || !data.result.status) {
                  this.$message({
                    type: 'error',
                    message: '该账号尚未注册，不存在！',
                    offset: 380,
                    grouping: true,
                  })
                } else {
                  this.dataForm.id = data.result.id                  
                  this.stepIndex = 2
                }
              }
            }).finally(() => {
              this.btnLoading = false
            })
          } else if (this.stepIndex === 2) { // 确定
            this.$post('/p/user/resetPasswordByMobileCode', this.dataForm, this, 'btnLoading').then(({ data }) => {
              if (data && data.code === 'C0000') {
                this.stepIndex = 3
              }
            })
          }
        }
      })
    },
    sign() {
      this.$post('/gateway/auth', {
        username: this.dataForm.mobile,
        password: this.dataForm.newPassword,
        loginType: 'pc',
        loginMode: 'mm',
        clientSource: '2',
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.authAfter(data)
        }
      }).finally(() => {
        setTimeout(() => {
          this.isloading = false
        }, 1000)
      })
    },      
    setAccount() {
      var curTime = new Date().getTime()
      localStorage.setItem(
        'information',
        JSON.stringify({ data: {userName: this.dataForm.mobile, password: this.dataForm.newPassword}, time: curTime })
      );
    },  
    authAfter(data) {
      this.setAccount()
      vueCookie.set('token', data.result.token, {
        domain: process.env.VUE_APP_DOADMIN
      });
      let accountId = data.result.loginAuthDto.accountId
      this.ActionsLoginId(accountId)
      this.activeMenu = ''
      this.mainTabs = []
      this.mainTabsActiveName = ''
      this.$utils.setSessionStorage('bizType', {
        clientImportRole: false,
        clientExportRole: false,
        clientWmsRole: false,
        activeIndex: '00'
      })
      // 初始化sessionStorage数据
      this.$initSessionStorageData.init()

      if (data.result.loginAuthDto.isAdmin) {
        this.$get('/p/user/getUsersByAccountId', { id: accountId }).then(({ data }) => {
          let userId = data.result[0].id
          this.ActionsUserId(userId)
          // 初始化sessionStorage数据
          this.$initSessionStorageData.init()
          
          this.$router.replace({
            path: '/',
            query: {
              isOuter: data.result[0].isOuter
                ? data.result[0].isOuter
                : ''
            }
          })
        })
        if(!(/^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])).{6,18}$/.test(this.dataForm.password))) {
          this.$message({
            type: 'warning',
            message: '您的密码过弱，建议您及时修改密码！',
            offset: 380,
            grouping: true
          })
        }
      } else {
        this.$post('/p/user/getUsersByAccountId', { id: accountId }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            if (!data.result.length) {
              this.$message({
                type: 'error',
                message: '当前用户没有租户信息',
                offset: 380,
                grouping: true
              })
            } else if (data.result.length === 1){
              this.tenantId = 0
              this.tenants = data.result
              this.setTenant(data.result[0].isOuter)
            } else {
              this.dialog = true
              this.tenants = data.result
            }
          }
        })
      }
    },
    setTenant(isOuter) {
      // userId
      let userId = this.tenants[this.tenantId].id
      this.ActionsUserId(userId);
      // tenantId
      this.ActionsTenantId(this.tenants[this.tenantId].tenantId)
      this.$post('/p/tenant/checkTenant', { id: this.tenants[this.tenantId].tenantId }).then(({ data }) => {
        if(!(/^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])).{6,18}$/.test(this.dataForm.password))) {
          this.$message({
            type: 'warning',
            message: '您的密码过弱，建议您及时修改密码！',
            offset: 380,
            grouping: true
          })
        }
        // 初始化sessionStorage数据
        this.$initSessionStorageData.init().then(() => {
          
          this.$router.replace({
            path: '/',
            query: { isOuter: isOuter ? isOuter : '' }
          })
        })
      })
    },
    // 获取手机验证码
    getMobileCode() {
      if (!/^1[0-9]{10}$/.test(this.dataForm.mobile)) {
        this.$message({
          type: 'error',
          message: '手机号格式不正确！',
          offset: 380,
          grouping: true,
        })
        return
      }
      this.codeDisabled = true
      this.$post('/p/user/sendChangePwdMobile', {
        mobile: this.dataForm.mobile,
        id: this.dataForm.id
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          let second = 60
          let timer = setInterval(() => {
            if (second <= 0) {
              clearInterval(timer)
              this.codeDisabled = false
              this.codeText = '获取验证码'
            } else {
              this.codeText = '重新获取(' + second + ')'
              second--
            }
          }, 1000)
        } else {
          this.codeDisabled = false
        }
      })
    },    
    ...mapActions([
      'ActionsLoginId',
      'ActionsUserId',
      'ActionsTenantId',
      'ActionsUpdateName'
    ])
  }
}
</script>

<style lang="scss">
.forgot-password-page {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: #aaa;
    &:hover {
      background: #999;
    }
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  .logo {
    position: absolute;
    left: 35px;
    top: 35px;
    height: 42px;
    i {
      display: inline-block;
      width: 189px;
      height: 42px;
      background-image: url(@/assets/img/logo.png);
    }
    span {
      display: inline-block;
      margin: 12px 0 0 16px;
      padding-left: 12px;
      font-size: 18px;
      line-height: 18px;
      color: #000;
      border-left: 1px solid #E5E5E5;
      vertical-align: top;
    }
  }
  .about {
    position: absolute;
    top: 35px;
    right: 35px;
    font-size: 16px;
    i {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin: 4px 8px 0 0;
      vertical-align: top;
      background: url(@/assets/img/about.png) no-repeat;
    }
    a {
      color: #111;
      text-decoration: none;
    }
  }
  .wrapper {
    width: 1360px;
    margin: 0 auto;
    padding-top: 100px;
  }
  .steps {
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 390px 50px;
    border-bottom: 1px solid #F0F2F5;
    &::after {
      content: '';
      position: absolute;
      left: 460px;
      top: 31px;
      z-index: 1;
      width: 437px;
      height: 0;
      border-bottom: 2px dashed #d6d6d6;
    }
    &.finish {
      &::after {
        border-color: #288bfd;
      }
    }
    .item {
      position: relative;
      z-index: 2;
      .hd {
        width: 64px;
        height: 64px;
        margin: 0 auto;
        padding-top: 14px;
        border-radius: 8px;
        background-color: #f2f7ff;
        i {
          display: block;
          width: 36px;
          height: 36px;
          margin: 0 auto;
          border: 3px solid #000;
          border-radius: 50%;
          font-size: 14px;
          font-weight: bold;
          font-style: normal;
          line-height: 30px;
          text-align: center;
        }
      }
      .title {
        margin-top: 12px;
        text-align: center;
        font-size: 16px;
        color: #000;
      }
      &.active {
        .hd {
          i {
            border-color: #288bfd;
            color: #288bfd;
          }
        }
      }
    }
  }
  .data-form {
    width: 580px;
    margin: 36px auto 0;
    .el-form-item {
      margin-bottom: 30px;
      .el-form-item__label {
        line-height: 14px;
      }
      .el-input__inner {
        height: 58px;
        line-height: 58px;
      }
    }
    .el-button {
      width: 100%;
      height: 50px;
      margin-top: 10px;
      border-radius: 8px;
      font-size: 16px;
      border-color: #0a7cff;
      color: #0a7cff;
    }
    .el-button--primary{
      color: #fff;
    }
    .return {
      margin-top: 40px;
      text-align: center;
      i {
        display: inline-block;
        width: 28px;
        height: 28px;
        margin-right: 10px;
        background: url(@/assets/img/return.png) no-repeat;
      }
      span {
        display: inline-block;
        line-height: 28px;
        vertical-align: top;
        cursor: pointer;
      }
    }
    .mobile-show {
      margin-bottom: 40px;
      .value {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 6px;
        .number {
          font-size: 22px;
        }
        .tips {
          color: #F87243;
        }
      }
    }
    .verify-code {
      .el-input-group__append {
        position: relative;
        padding: 0 30px;
        color: #000;
        box-shadow: none;
        background: #f0f2f5;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 17.5px;
          width: 1px;
          height: 25px;
          background: #e5e5e5;
        }
        .el-button {
          margin: 0;
          min-width: auto;
        }
      }
    }
  }
  .success {
    margin-top: 164px;
    text-align: center;
    .icon {
      width: 112px;
      height: 68px;
      margin: 0 auto;
      transform: translateX(20px);
      background: url(@/assets/img/success.png) no-repeat;
    }
    .text {
      margin-top: 15px;
    }
    .el-button {
      width: 140px;
      margin-top: 36px;
    }
  }
}
</style>
